<mat-card appearance="outlined">
  @if (templateSelect) {
    <ng-container>
      <mat-card-header>
        <mat-card-title>
          {{ template.title }}
        </mat-card-title>
      </mat-card-header>
      <span class="image-container">
        <app-site-screen-shot
          [screen_shot]="this.screenshotUrl"
          [fallback_iframe]="template.domain"
        ></app-site-screen-shot>
      </span>
      <span class="overlay-text">
        <button mat-button (click)="navigateToTemplate()">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.PREVIEW' | translate }}
          {{ template.title }}
        </button>
        <br />
        <button class="use-template" mat-raised-button (click)="selectTemplate()">
          {{ useTemplateButton }}{{ template.title }}
        </button>
      </span>
      @if (!!icon) {
        <span>
          <button class="star" mat-icon-button [matTooltip]="this.ecommerceSubtitle">
            <img src="{{ icon }}" alt="" />
          </button>
        </span>
      }
    </ng-container>
  } @else {
    <mat-card-header>
      <mat-card-title>
        {{ template.title }}
      </mat-card-title>
    </mat-card-header>
    <span class="image-container">
      <app-site-screen-shot
        [screen_shot]="this.screenshotUrl"
        [fallback_iframe]="template.domain"
      ></app-site-screen-shot>
    </span>
    @if (isCreating) {
      <span class="overlay-text">
        <mat-spinner [diameter]="60" [strokeWidth]="8" color="accent"></mat-spinner>
        <span class="template-creating-message">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.DUPLICATE_WAIT_MESSAGE' | translate }}
          <br />
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.DUPLICATE_READY_SOON' | translate }}
        </span>
      </span>
    } @else {
      <span class="overlay-text">
        <button mat-button (click)="navigateToTemplate()">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.PREVIEW' | translate }}
          {{ template.title }}
        </button>
        <br />
        <button mat-button [disabled]="!ready || isStaging" (click)="showDuplicateTemplateDialog()">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.DUPLICATE_TEMPLATE' | translate }}
        </button>
        <br />
        <button mat-button [disabled]="(!ready && allowedToEdit) || isStaging" (click)="selectTemplate()">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.EDIT_TEMPLATE' | translate }}
        </button>
        <br />
        <button mat-button [disabled]="!ready || isStaging" (click)="showDeleteTemplateDialog()">
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SELECTION.DELETE' | translate }}
        </button>
      </span>
    }
    <ng-template #callDuplicateDialog>
      <mat-card appearance="outlined" class="duplicate-dialog">
        <div>
          <mat-card-header>
            <mat-card-title>
              {{ 'PAGES.CREATE_FROM_TEMPLATES.DUPLICATE_DIALOG.TITLE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <form (ngSubmit)="duplicateTemplate()">
            <p>
              <mat-form-field class="duplicate-dialog-form">
                <label for="input"></label>
                <input
                  id="input"
                  matInput
                  type="text"
                  [required]="true"
                  name="siteTitle"
                  [(ngModel)]="duplicationForm.siteTitle"
                  placeholder="{{ 'PAGES.MANAGE_TEMPLATES.CREATE.NAME' | translate }}"
                  maxLength="{{ maxLength }}"
                />
                @if (!!duplicationForm.siteTitle && duplicationForm.siteTitle.length > maxLength - 15) {
                  <mat-hint>
                    {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
                    {{ calculateRemainingChars(duplicationForm.siteTitle.length) }}
                  </mat-hint>
                }
              </mat-form-field>
            </p>
            <div class="duplicate-dialog-buttons" [glxyPopover]="popover">
              <button mat-raised-button class="duplicate-dialog-cancel" type="button" (click)="duplicateDialog.close()">
                {{ 'PAGES.CREATE_FROM_TEMPLATES.DUPLICATE_DIALOG.CANCEL' | translate }}
              </button>
              <span
                (mouseenter)="
                  !isLessMaxTemplates || duplicateButtonDisabled || !duplicationForm.siteTitle.trimStart().length
                    ? showPopovers()
                    : null
                "
                (mouseleave)="hidePopovers()"
              >
                <button
                  mat-raised-button
                  [disabled]="
                    !isLessMaxTemplates || duplicateButtonDisabled || !duplicationForm.siteTitle.trimStart().length
                  "
                  class="duplicate-dialog-confirm"
                  type="submit"
                  color="accent"
                >
                  {{ 'PAGES.CREATE_FROM_TEMPLATES.DUPLICATE_DIALOG.CONFIRM' | translate }}
                </button>
              </span>
            </div>
          </form>
        </div>
      </mat-card>
      <glxy-popover
        #popover
        [isOpen]="showPopover"
        [positions]="[PopoverPositions.Top]"
        [hasArrow]="false"
        [padding]="'small'"
      >
        {{ duplicatePopoverText }}
      </glxy-popover>
    </ng-template>
  }
</mat-card>
